@if (isWorking) {
  <div class="overlay" >
    <div class="spinner clickable" (click)="close()">
      <rask-busy-tree></rask-busy-tree>
      <span>{{ getLabel() }}</span>
    </div>
  </div>
}
